// src/store/index.ts
import { configureStore } from "@reduxjs/toolkit";
import { enableMapSet } from "immer";
import dashboardReducer from "./dashboardSlice.ts";

// 启用Immer的MapSet插件
enableMapSet();

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
